import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const _GetCurrentUserRequestDtoSchema = z.object();

const GetCurrentUserResponseDtoSchema = UserDtoSchema;

export type GetCurrentUserRequestDto = z.infer<
  typeof _GetCurrentUserRequestDtoSchema
>;
export type GetCurrentUserResponseDto = z.infer<
  typeof GetCurrentUserResponseDtoSchema
>;

export const getCurrentUser = (
  config?: AxiosRequestConfig<GetCurrentUserRequestDto>
) => {
  return api
    .get('/users/me', config)
    .then(responseContract(GetCurrentUserResponseDtoSchema));
};
